import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../reducers/auth_reducer";
import loadingReducer from "../reducers/loading_reducer";
import modalReducer from "../reducers/modal_reducer";
import modalStateReducer from "../reducers/modal_state_reducer";
import RootCombinedReducer from "../reducers/root_reducer";
import RoutesCombinedReducer from "../reducers/routes_reducer";
import slideoverReducer from "../reducers/slideover_reducer";
import slideoverStateReducer from "../reducers/slideover_state_reducer";
import staticReducer from "../reducers/static_reducer";
import triggerReducer from "../reducers/trigger_reducer";

// ...

export const store = configureStore({
  reducer: {
    root: RootCombinedReducer,
    routes: RoutesCombinedReducer,
    auth: authReducer,
    staticAPI: staticReducer,
    loading: loadingReducer,
    modals: modalReducer,
    modal_states: modalStateReducer,
    slideovers: slideoverReducer,
    slideover_states: slideoverStateReducer,
    triggers: triggerReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
